import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_contract_workers_employed_by_third_party_not_part_of_the_production_process'

export const dataPointDefinition = {
  retracedId: 'num_of_contract_workers_employed_by_third_party_not_part_of_the_production_process',
  name: 'Number of contract workers/ workers employed by third party who are not part of the production process:',
  description:
    '"Contract workers who are not part of the production process" refers to persons not working on/with the facility\'s product or directly involved in the operations of the facility and who are under contract with an organization other than the facility to work at the facility for a specified duration. \r\r\n\r\r\nExamples include workers who are at the facility and employed by a third party to do work in security, maintenance, cleaning, etc.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-wor-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1300,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
